import { FC } from 'react';
import {
  DataGridFieldBaseProps,
  DataGridFieldInjectedProps,
} from '../../../ui';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { QualityClass, ScanStatus } from '../../network';
import { QualityClassChip, ScanStatusChip } from '../../ui/ScanStatusChips';

export type DataGridScanStatusFieldProps = DataGridFieldBaseProps &
  DataGridFieldInjectedProps;

export const ScanStatusCellRenderer: FC<GridRenderCellParams> = (props) => {
  const { value, row } = props;
  const status = value as ScanStatus;
  const predicted_bent_deviation_mesh_quality_class =
    row.predicted_bent_deviation_mesh_quality_class as QualityClass;

  return (
    <>
      <ScanStatusChip status={status} />
      <span style={{ marginLeft: '4px' }}>
        <QualityClassChip
          qualityClass={predicted_bent_deviation_mesh_quality_class}
        />
      </span>
    </>
  );
};
